import Quill from 'quill';

const Module = Quill.import('core/module');
const Block: any = Quill.import('blots/block');

class DirectionModule extends Module {

    constructor(quill, options) {
        super(quill, options);
        const toolbar = quill.getModule('toolbar');
        if (toolbar) {
            toolbar.addHandler('direction', this.toggleDirection.bind(this, quill));
        }
    }

  toggleDirection(quill, value) {
    const range = quill.getSelection();
    if (!range) return;
    const format = quill.getFormat(range);
    const newDirection = format.direction === 'rtl' ? 'ltr' : 'rtl';
    const lines = quill.getLines(range.index, range.length);

    lines.forEach(line => {
      const node = line.domNode;

      node.classList.remove('ql-align-left', 'ql-align-center', 'ql-align-justify', 'ql-align-right', 'ql-direction-rtl');

      if (newDirection === 'rtl') {
        node.style.direction = 'rtl';
        node.style.textAlign = 'right';
        node.classList.add('ql-direction-rtl');
        node.classList.add('ql-align-right');
      } else {
        node.style.direction = 'ltr';
        node.style.textAlign = 'left';
      }

      quill.formatLine(quill.getIndex(line), line.length(), {
        'direction': newDirection,
        'align': newDirection === 'rtl' ? 'right' : 'left'
      }, 'user');
    });
  }
}


class AlignBlot extends Block {
  static create(value) {
    let node = super.create();
    if (typeof value === 'string') {
      node.classList.add(`ql-align-${value}`);
      node.style.textAlign = value;
    }
    return node;
  }

  static formats(node) {
    const align = node.className.match(/ql-align-(\w+)/)?.[1];
    const direction = node.style.direction || 'ltr'; // Default to 'ltr' if not set
    return { align, direction };
  }

  format(name, value) {
    if (name === 'align') {
      const alignValue = typeof value === 'string' ? value : '';
      const oldAlign = this.domNode.className.match(/ql-align-(\w+)/)?.[1];
      if (oldAlign) {
        this.domNode.classList.remove(`ql-align-${oldAlign}`);
      }
      if (alignValue) {
        this.domNode.classList.add(`ql-align-${alignValue}`);
        this.domNode.style.textAlign = alignValue;
      }
    } else if (name === 'direction') {
      const directionValue = typeof value === 'string' ? value : '';
      this.domNode.style.direction = directionValue;
      if (directionValue === 'rtl') {
        this.domNode.classList.add('ql-direction-rtl');
      } else {
        this.domNode.classList.remove('ql-direction-rtl');
      }
    } else {
      super.format(name, value);
    }
  }
}

Quill.register(AlignBlot);
Quill.register('modules/directionModule', DirectionModule);

export default DirectionModule;
